export default __webpack_public_path__ + "static/media/CPD Advertising Flyer.94094d33.pdf";